import type { InterventionIndicatorProps } from "./intervention-indicator.type";

import { Flex } from "antd";

import { InterventionSchedulingIndicator } from "./intervention-indicator-scheduling";
import { InterventionStateIndicator } from "./intervention-indicator-state";

export const InterventionIndicator = ({
  intervention,
  isBig,
}: InterventionIndicatorProps) => {
  if (!intervention?.state) return null;

  return (
    <Flex align="center" gap={6} className="intervention-indicator">
      <InterventionSchedulingIndicator
        schedulingState={intervention.scheduling_state}
        isBig={isBig}
        showLabel={true}
      />
      {intervention?.state && (
        <InterventionStateIndicator intervention={intervention} isBig={isBig} />
      )}
    </Flex>
  );
};
